import { useQuery } from "@tanstack/react-query";
import { getReportTopProducts } from "../../api/apiReports";

export const useGetReportTopProducts = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-top-products", params],
        queryFn: () => getReportTopProducts(params),
        retry: false,
    });

    return {
        items: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
